import { App } from '@/app/App';
import { initErrorTracking, initVitals, track } from '@/lib/telemetry';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';

// Telemetry — init global error/vital reporters before the app mounts.
// Events are queued in IDB and flushed after sign-in (see AuthProvider).
initErrorTracking();
initVitals();

// app_opened: queue immediately (pre-auth); flushed after sign-in.
// cold_start: true when there's no prior activity in this session.
// source: 'launcher' for direct navigations, 'link' if there's a referrer.
track('app_opened', {
  cold_start: !document.referrer,
  source: document.referrer ? 'link' : 'launcher',
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
